export type RaffleStore = {
  id: string
  name: string
  address: string
}

export const FC_STORES: Record<string, RaffleStore> = {
  'New York': {
    id: 'fc-nyc',
    name: 'Flight Club New York',
    address: '812 Broadway New York, NY 10003',
  },
  'Los Angeles': {
    id: 'fc-la',
    name: 'Flight Club Los Angeles',
    address: '535 N Fairfax Ave, Los Angeles, CA 90036',
  },
  'Miami': {
    id: 'fc-mia',
    name: 'Flight Club Miami',
    address: '3910 NE 1st Ave, Miami, FL 33137',
  },
}
